import ACTIONS from '../../actions';
import { loadFromStorage, saveToStorage } from '../util';
var initialState = {
  id: null,
  name: null,
  timezone: loadFromStorage('environment.settings.timezone', null) //rehydrate

};

var settingsReducer = function settingsReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case ACTIONS.ENV_SETTINGS_GET_RESOLVED:
      {
        if (action.payload.timezone) saveToStorage('environment.settings.timezone', action.payload.timezone);
        return action.payload;
      }

    default:
      return state;
  }
};

export default settingsReducer;